module.exports = __webpack_public_path__ + "img/盖章@2x.672d1f4f.png";